var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-block"},[_c('strong',[_vm._v("Data:")]),_vm._v(" "+_vm._s(_vm.date)+" "),_c('br'),_vm._v(" (Horário de Brasília) ")])}
var staticRenderFns = []

export { render, staticRenderFns }